module.exports = __webpack_public_path__ + "img/background-placeholder.bfa7c10a.svg";